import React, { useState } from 'react';

import FeaturedOrganizationCard from './components/FeaturedOrganizationCard';
import WithLoveFooter from './components/Footer';
import LetterModal from './components/LetterModal';
import Marquee from './components/Marquee';
import OrganizationCard from './components/OrganizationCard';
import StorySection from './components/StorySection';
import VideoPlayer from './components/VideoPlayer';
import { allOrganizationCards } from './constants';

import * as S from './styles';
import { OrganizationCard as OrganizationCardType } from './types';

function WithLove() {
  const [isLetterModalOpen, setIsLetterModalOpen] = useState(false);
  const [selectedCardForLetter, setSelectedCardForLetter] =
    useState<OrganizationCardType | null>(null);

  const featuredCard = allOrganizationCards.find((card) => card.isFeatured);
  const otherCards = allOrganizationCards.filter((card) => !card.isFeatured);

  function handleCardClick(cardId: string) {
    const clickedCard = allOrganizationCards.find((card) => card.id === cardId);

    if (!clickedCard) {
      return;
    }

    handleOpenLetter(clickedCard);
  }

  function handleOpenLetter(card: OrganizationCardType) {
    setSelectedCardForLetter(card);
    setIsLetterModalOpen(true);
  }

  function handleCloseLetter() {
    setIsLetterModalOpen(false);
  }

  function handleReadAnother() {
    handleCloseLetter();
  }

  function handleVisitOrg() {
    if (selectedCardForLetter?.letterUrl) {
      window.open(selectedCardForLetter.letterUrl, '_blank');
    }
  }

  return (
    <S.Container>
      <S.BlackBar />
      <S.HeaderSection>
        <S.SubtitleText>You made it.</S.SubtitleText>
        <S.HeadingContainer>
          <S.HeadingText>Welcome.</S.HeadingText>
          <S.HeadingText>
            We&apos;re so glad you found your way to us.
          </S.HeadingText>
        </S.HeadingContainer>
      </S.HeaderSection>

      <S.VideoSection>
        <VideoPlayer />
      </S.VideoSection>

      <S.MarqueeSection>
        <Marquee
          phrases={[
            <S.MarqueeText key="welcome">
              <span>WITH LOVE, </span> <span>WELCOME</span>
            </S.MarqueeText>,
            <S.MarqueeText key="thank-you">
              <span>WITH LOVE, </span> <span>THANK YOU</span>
            </S.MarqueeText>,
          ]}
          speed={80}
        />
      </S.MarqueeSection>

      <S.GallerySection>
        <S.GalleryHeadingContainer>
          <S.GalleryHeadingText>Our Campaign Ecosystem</S.GalleryHeadingText>
          <S.GalleryHeadingSubtitle>
            & their warm welcome notes to you
          </S.GalleryHeadingSubtitle>
        </S.GalleryHeadingContainer>

        <S.CardsContainer>
          {featuredCard && (
            <S.FeaturedCardWrapper>
              <FeaturedOrganizationCard
                organization={featuredCard}
                onOpenLetter={() => handleOpenLetter(featuredCard)}
              />
            </S.FeaturedCardWrapper>
          )}

          {otherCards.length > 0 && (
            <S.OrganizationCardsGrid>
              {otherCards.map((card) => (
                <OrganizationCard
                  card={card}
                  key={card.id}
                  // onClick={() => handleCardClick(card.id)}
                />
              ))}
            </S.OrganizationCardsGrid>
          )}
        </S.CardsContainer>

        <S.LastUpdatedText>
          <span>Learn more about why we&apos;ve come together</span>
          <span>Last updated: 2/1/2026</span>
        </S.LastUpdatedText>
      </S.GallerySection>

      <S.StorySectionMarqueeDivider>
        <Marquee
          phrases={[
            <S.MarqueeText key="welcome">
              <span>WITH LOVE, </span> <span>WELCOME</span>
            </S.MarqueeText>,
            <S.MarqueeText key="thank-you">
              <span>WITH LOVE, </span> <span>THANK YOU</span>
            </S.MarqueeText>,
          ]}
          speed={80}
        />
      </S.StorySectionMarqueeDivider>

      <S.StorySectionContainer>
        <S.StorySectionHeading>
          Three moments from the film
        </S.StorySectionHeading>
        <StorySection />
      </S.StorySectionContainer>

      <S.FooterContainer>
        <WithLoveFooter />
      </S.FooterContainer>

      <S.BlackBar />

      <LetterModal
        card={selectedCardForLetter}
        open={isLetterModalOpen}
        onClose={handleCloseLetter}
        onReadAnother={handleReadAnother}
        onVisitOrg={handleVisitOrg}
      />
    </S.Container>
  );
}

export default WithLove;
